/** @deprecated use location.origin to instead */
export default function getUrlPrefix() {
  return `${window.location.protocol}//${window.location.hostname}`;
}
